import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";

const PlanUpgrade = ({ feature = "this feature", plan }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 4,
          textAlign: "center",
          maxWidth: 460,
          width: "100%",
          background: "linear-gradient(135deg, #fef9c3, #fef3c7)",
          border: "1px solid #fde68a",
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "#f59e0b20",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <LockIcon sx={{ fontSize: 28, color: "#f59e0b" }} />
        </Box>
        <Typography fontWeight={800} fontSize={20} color="#92400e" mb={1}>
          Upgrade Required
        </Typography>
        <Typography variant="body2" color="#b45309" mb={0.5}>
          <strong>{feature}</strong> is not available on your current plan.
        </Typography>
        {plan && (
          <Typography variant="body2" color="#b45309" mb={2}>
            Your plan: <strong>{plan}</strong>
          </Typography>
        )}
        <Button
          variant="contained"
          startIcon={<UpgradeIcon />}
          onClick={() => navigate("/app/plans")}
          sx={{
            mt: 1,
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 700,
            px: 4,
            background: "linear-gradient(135deg, #f59e0b, #d97706)",
            "&:hover": { background: "linear-gradient(135deg, #d97706, #b45309)" },
          }}
        >
          View Plans
        </Button>
      </Paper>
    </Box>
  );
};

export default PlanUpgrade;
